package ui.styles

import emotion.css.ClassName
import ui.pages.Area
import ui.pages.Sizes
import web.cssom.*


object Styles {
    object MainScreenComp {
        val mainScreenCmp = ClassName(ClassName("MainScreenCmp")) {
            display = Display.grid

            width = 100.pct
            maxWidth = 920.px

            gap = 10.px

            gridTemplateColumns = array(
                Auto.auto
            )
            gridTemplateRows = array(
                Auto.auto,
                Auto.auto,
                Auto.auto,
            )
            gridTemplateAreas = GridTemplateAreas(
                arrayOf(Area.MainScreenCmp.error),
                arrayOf(Area.MainScreenCmp.head),
                arrayOf(Area.MainScreenCmp.main)
            )
        }

        val msHead = ClassName(ClassName("msHead")) {
            gridArea = Area.MainScreenCmp.head
        }
        val msError = ClassName(ClassName("msError")) {
            gridArea = Area.MainScreenCmp.error
        }
        val msMain = ClassName(ClassName("msMain")) {
            gridArea = Area.MainScreenCmp.main
        }
    }

    object Expanded {
        val expandedText = ClassName(ClassName("expanded_text")) {

        }
        val expandedTextExp = ClassName(ClassName("expanded_text_e")) {

        }
        val expandedTextBtn = ClassName(ClassName("exp_btn")) {

        }
    }

    object ContentBox {
        val contentBox = ClassName(ClassName("main_box")) {
            gridArea = Area.Content
        }
    }

    object ErrorPage {
        val errorPageContainer = ClassName(ClassName("error_page_container")) {

        }
    }

    object Page {
        val pageBox = ClassName(ClassName("page_box")) {

            display = Display.grid

            gridTemplateRows = array(//вертикальная настройка
                Sizes.Header.Height,
                Auto.auto,
                Sizes.Footer.Height,
            )

            gridTemplateColumns = array(//горизонтальная настройка
                Auto.auto,
            )

            gridTemplateAreas = GridTemplateAreas(//сетка компонентов
                arrayOf(/*Area.Header,*/ Area.Header),
                arrayOf(/*if (isMobile) Area.Content else Area.Sidebar,*/Area.Content),
                arrayOf(/*Area.Footer,*/Area.Footer)
            )
        }
    }

    object Header {

        val headerBox = ClassName(ClassName("header_box")){

            display = Display.grid
            gridArea = Area.Header

            gridTemplateRows = array(
                Sizes.Header.Height
            )

            gridTemplateColumns = array(
                25.vw,
                Auto.auto,
                25.vw
            )

            gridTemplateAreas = GridTemplateAreas(
                arrayOf(Area.HeaderBox.left, Area.HeaderBox.center, Area.HeaderBox.right)
            )
        }

        val headerTitle = ClassName{
            display = Display.flex
            justifyContent = JustifyContent.center
            alignItems = AlignItems.center
            gridArea = Area.HeaderBox.center
            alignContent = AlignContent.center
        }
        val headerLeftBlock = ClassName{
            gridArea = Area.HeaderBox.left
            alignContent = AlignContent.center

            gap = 10.px

            display = Display.flex
            flexWrap = FlexWrap.wrap
            justifyContent = JustifyContent.left
        }
        val headerRightBlock = ClassName{
            gridArea = Area.HeaderBox.right
            alignContent = AlignContent.center

            display = Display.flex
            flexWrap = FlexWrap.wrap
            justifyContent = JustifyContent.right
        }

    }

    object Footer {
        val FooterBox = ClassName(ClassName("footer_box")){
            height = Sizes.Footer.Height

            width = 100.pct
            position = Position.fixed
            bottom = 0.px

            gridArea = Area.Footer
            display = Display.grid


            gridTemplateRows = array(
                Auto.auto
            )
            gridTemplateColumns = array(
                Auto.auto,
                Auto.auto,
                Auto.auto
            )
            gridTemplateAreas = GridTemplateAreas(
                arrayOf(Area.FooterBox.left, Area.FooterBox.center, Area.FooterBox.right)
            )
        }
    }

    object Skeletoner{
        val skeletoner = ClassName(ClassName("Skeletoner")){

        }
    }

    object Buttons{
        val linkText = ClassName(ClassName("link_text")){

        }

        val button = ClassName(ClassName("Button")){

        }
        val buttonTarget = ClassName(ClassName("button_target")){

        }

        val buttonModifiedForElementF = ClassName(ClassName("button_modified_for_element_f")){

        }
        val tokenButtonModifiedForElementF = "button_modified_for_element_f"

        val buttonModifiedForElementM = ClassName(ClassName("button_modified_for_element_m")){

        }
        val tokenButtonModifiedForElementM = "button_modified_for_element_m"

        val buttonModifiedForElementL = ClassName(ClassName("button_modified_for_element_l")){

        }
        val tokenButtonModifiedForElementL = "button_modified_for_element_l"

        val buttonInset = ClassName(ClassName("Button_inset")){

        }

        val iconButton = ClassName(ClassName("icon_button")){

        }

        val miniIconButton = ClassName(ClassName("mini_icon_button")){

        }

    }

    object Elements{
        val divider = ClassName(ClassName("divider")){

        }

        val card = ClassName(ClassName("card_my_main")){
            marginInline = 10.px
        }

        val tabsHeaderListItem = ClassName(ClassName("tabs_header_list_item")){

        }

        val listItem = ClassName(ClassName("ListItem")){
            position = Position.relative
            display = Display.flex
            justifyContent = JustifyContent.spaceBetween
        }

        val tabsHeader = ClassName(ClassName("tabs_header")){

        }

        val tab = ClassName(ClassName("Tab")){

        }

        val tabTarget = ClassName(ClassName("tab_target")){

        }
    }

}
